import { FC } from "react";
import { Dayjs } from "dayjs";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import PassengerDateFieldWeb from "./layouts/PassengerDateField.web";
import PassengerDateFieldMob from "./layouts/PassengerDateField.mob";

const PassengerDateFieldComponent = withConditionalComponent(PassengerDateFieldWeb, PassengerDateFieldMob);

export type PassengerDateFieldProps = {
  value?: string | Dayjs;
  onChange?: (value: Dayjs) => void;
  label?: string;
  disabledDate?: (date: Dayjs) => boolean;
  className?: string;
};

const PassengerDateField: FC<PassengerDateFieldProps> = (props) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <PassengerDateFieldComponent trigger={isLargeScreen} props={props} />;
};

export default PassengerDateField;
